module.exports = __webpack_public_path__ + "static/media/Avenir-MediumOblique.2abbd8ee.woff";